/* istanbul ignore file */
"use strict";

import _classCallCheck from "/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { UrlJsonRpcProvider } from "./url-json-rpc-provider";
import { Logger } from "@ethersproject/logger";
import { version } from "./_version";
var logger = new Logger(version); // Special API key provided by Nodesmith for ethers.js

var defaultApiKey = "ETHERS_JS_SHARED";
export var NodesmithProvider = /*#__PURE__*/function (_UrlJsonRpcProvider) {
  _inherits(NodesmithProvider, _UrlJsonRpcProvider);

  var _super = _createSuper(NodesmithProvider);

  function NodesmithProvider() {
    _classCallCheck(this, NodesmithProvider);

    return _super.apply(this, arguments);
  }

  _createClass(NodesmithProvider, null, [{
    key: "getApiKey",
    value: function getApiKey(apiKey) {
      if (apiKey && typeof apiKey !== "string") {
        logger.throwArgumentError("invalid apiKey", "apiKey", apiKey);
      }

      return apiKey || defaultApiKey;
    }
  }, {
    key: "getUrl",
    value: function getUrl(network, apiKey) {
      logger.warn("NodeSmith will be discontinued on 2019-12-20; please migrate to another platform.");
      var host = null;

      switch (network.name) {
        case "homestead":
          host = "https://ethereum.api.nodesmith.io/v1/mainnet/jsonrpc";
          break;

        case "ropsten":
          host = "https://ethereum.api.nodesmith.io/v1/ropsten/jsonrpc";
          break;

        case "rinkeby":
          host = "https://ethereum.api.nodesmith.io/v1/rinkeby/jsonrpc";
          break;

        case "goerli":
          host = "https://ethereum.api.nodesmith.io/v1/goerli/jsonrpc";
          break;

        case "kovan":
          host = "https://ethereum.api.nodesmith.io/v1/kovan/jsonrpc";
          break;

        default:
          logger.throwArgumentError("unsupported network", "network", arguments[0]);
      }

      return host + "?apiKey=" + apiKey;
    }
  }]);

  return NodesmithProvider;
}(UrlJsonRpcProvider);